import httpClient from './httpClient';
const prefix = 'core'
export default {
    async getAll () {
        const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/businessType/getAll`)
    
        return data
      }
}